/**
 * Created by decipaliz on 15.03.2023
 */

ComingSoonLocationView.prototype.customize = cleverapps.extendFunc(ComingSoonLocationView.prototype.customize, function () {
    // eslint-disable-next-line prefer-spread,prefer-rest-params
    this._super.apply(this, arguments);

    const styles = cleverapps.styles.LocationView.comingSoon.character;
    if (!styles) {
        return;
    }

    // TODO: fixsize
    const person = new cleverapps.Spine(bundles.coming_soon.jsons.coming_soon_hero_json);
    person.setAnimation(0, "coming_soon", true);
    person.setPosition(styles.x, styles.y);
    this.addChild(person);
});

ComingSoonLocationView.prototype.addBackground = function () {
    this.addDefaultBackground();
};